/* App flow redirection */

// import Settings from "./settings.service";
import { isLoggedIn } from "./helpers";
import { BehaviorSubject } from "rxjs";
import { arrayToObject } from "./helpers";
import Steps from "../static/steps.data";
import Storage from "./storage.service";
// import { CONSTANTS } from "./constants.service";
import { generalEvent } from "./tracking.service";
var Flow = {
	routeTo: null,
	loaded: false,
};

const slash = "/";

let steps = [];
let paths = [];
Flow.starting_point = null;
var obsrv = new BehaviorSubject(Flow.routeTo);

var loaded = new BehaviorSubject(Flow.loaded);

const getRouteObsrv = () => {
	return obsrv.asObservable();
};

const skipCoverageMap = () => {
	let flags = Storage.get("flow_status_flags") || {};
	let is_number_selected = flags["is_number_selected"];
	let is_plan_selected = flags["is_plan_selected"];
	if (Storage.get("modem_latlng", true)) {
		if (is_number_selected && is_plan_selected) {
			return true;
		} else {
			Storage.clear("modem_latlng");
		}
	} else {
		if (is_plan_selected && is_number_selected) {
			return true;
		}
	}
	return false;
};

const checkFlag = (flag) => {
	let flags = Storage.get("flow_status_flags") || {};
	let req_prop = flag;
	let condition = true;

	if (req_prop.startsWith("!")) {
		req_prop = req_prop.replace("!", "");
		condition = false;
	}

	let val = flags[req_prop] || Storage.get(req_prop, true);

	if (flag === "is_done") {
		val = isDone();
	}

	if (flag === "skip_coverage_map") {
		val = skipCoverageMap();
	}

	val = !!val;

	return val === condition;
};

const getCurrentRoute = () => {
	return Flow.routeTo;
};

const getRoutes = () => {
	return Flow.routes;
};

const isRouteAFullURL = (route = "/") => {
	return route.indexOf("http:/") !== -1 || route.indexOf("https:/") !== -1;
};

const loadFlow = () => {
	return loaded.asObservable();
};

const mapSubs = (steps) => {
	let f = {};
	for (let step of steps) {
		for (let sub of step.subs) {
			f[sub] = { path: step.path, order: step.order, key: step.key };
		}
	}
	return f;
};

const getStepBaseOf = (current) => {
	if (Flow.routes[current]) {
		return Flow.routes[current]["path"];
	} else {
		return -1;
	}
};

const goToStepBase = (current) => {
	if (Flow.routes[current]) {
		goToRouteWithChecks(Flow.routes[current]["path"]);
	} else {
		let recommended = getRecommendedRoute(8);
		goToRouteWithChecks(recommended);
	}
};

const goToRouteWithChecks = (route) => {
	if (isRouteAFullURL(route)) {
		goToHref(route);
	} else {
		goTo(route);
	}
	if(!window.location.href.includes('payment')){
		generalEvent({ eventType : "virtualPageView"})
	}
};

const goTo = (route = null) => {
	if (!route || !isRouteAllowed(route, "2")) {
		route = getRecommendedRoute(9);
		// log("recommended", route);
	}

	if (route !== Flow.routeTo) {
		if (Flow.routeTo !== null) {
			Storage.set("navigating_within_app", true);
		}
		if(route === '/collect-in-store' && Storage.get('valid_id_holder', true) === true){
			route = '/delivery';
		}
		let deliveryRoutes = ['/delivery', '/delivery_type' ,'/delivery_address'];
		if(deliveryRoutes.includes(route) && Storage.get('valid_id_holder', true) === false){
			route = '/payment';
		}
		if (isRouteAFullURL(route)) {
			goToHref(route);
		} else {
			// let step = Flow.getStepNameByPath(route);
			Flow.routeTo = route;
			obsrv.next(Flow.routeTo);
		}
	}
};

const goToHref = (route) => {
	window.location.href = route;
};

const goToStart = () => {
	goTo(Flow.starting_path["path"]);
};

const isRouteAllowed = (route, callee = null) => {
	let allowed = false;
	let flags = Storage.get("flow_status_flags") || {};

	if (isLoggedIn() && flags) {
		// let done = isDone();

		let requires = [];

		if (Flow.paths[route]) {
			requires = Flow.paths[route]["requires"];
		}
		if (!requires || requires.length === 0) {
			allowed = true;
		} else {
			allowed = true;
			for (let req of requires) {
				allowed = checkFlag(req);
				if (!allowed) {
					break;
				}
			}
		}
	}
	if (route === slash) {
		allowed = true;
	}

	return allowed;
};

const back = (current) => {
	let route = "";
	if (current) {
		route = getPrevRouteOf(current);

		if (!isRouteAllowed(route, "433")) {
			let current_order = stepNumberOf(current);
			if (Flow.steps[current_order - 1]) {
				route = getPrevRouteOf(Flow.steps[current_order - 1]["key"]);
				// Flow.steps[current_order + 2]["path"];
			} else {
				route = getRecommendedRoute(13332);
			}
		}
	} else {
		route = getRecommendedRoute(1231);
	}

	goToRouteWithChecks(route);
};

const next = (current) => {
	let route = "";

	if (current) {
		route = getNextRouteOf(current);

		if (!isRouteAllowed(route, "4")) {
			let current_order = stepNumberOf(current);

			if (Flow.steps[current_order + 1]) {
				route = getNextRouteOf(Flow.steps[current_order + 1]["key"]);

				// Flow.steps[current_order + 2]["path"];
			} else {
				route = getRecommendedRoute(132);
			}
		}
	} else {
		route = getRecommendedRoute(11);
	}

	goToRouteWithChecks(route);
};

const getNextRouteOf = (current) => {
	let route = slash;
	if (Flow.routes[current]) {
		let current_index = Flow.routes[current]["order"];
		route = Flow.steps[current_index + 1 + ""]
			? Flow.steps[current_index + 1 + ""]["path"]
			: Flow.steps[current_index + ""]["path"];
	} else {
		route = getRecommendedRoute(12);
	}
	return route;
};

const getPrevRouteOf = (current) => {
	let route = slash;
	if (Flow.routes[current]) {
		let current_index = Flow.routes[current]["order"];
		route = Flow.steps[current_index - 1 + ""]
			? Flow.steps[current_index - 1 + ""]["path"]
			: Flow.steps[current_index + ""]["path"];
	} else {
		route = getRecommendedRoute(13);
	}
	return route;
};

const getStepStyleByPath = (path) => {
	if (Flow.paths && Flow.paths[path]) {
		return Flow.paths[path]["style"];
	}
	if (Flow.sub_paths && Flow.sub_paths[path]) {
		return Flow.sub_paths[path]["style"];
	}
	if (path === '/installments'){
		return "vmo-header-style-slant";
	}
	return "default";
};

const getStepOrderByPath = (path) => {
	if (Flow.paths && Flow.paths[path]) {
		return Flow.paths[path]["order"];
	}
	if (Flow.sub_paths && Flow.sub_paths[path]) {
		return Flow.sub_paths[path]["order"];
	}
	return "default";
};

const getStepNameByPath = (path) => {
	if (Flow.paths[path]) {
		let step = Flow.paths[path]["key"];
		return step;
	}
	if (Flow.sub_paths[path]) {
		let order = Flow.sub_paths[path]["key"];
		return order;
	}
	return "";
};

const getStepByPath = (path) => {
	if (Flow.paths[path]) {
		return Flow.paths[path];
	}
	return null;
};

const navigateFromDeniedPath = (denied_path) => {
	let recommended = getRecommendedRoute(2);
	let flow_status_order = pathNumberOf(recommended);
	let destination_order = pathNumberOf(denied_path);
	let isSub = isSubPath(denied_path);
	let DeniedStep = getStepByPath(denied_path);
	let routeTo = "";

	if (destination_order < flow_status_order) {
		// Trying to go back

		if (destination_order > 1) {
			routeTo = isSub ? denied_path : getPrevRouteOf(DeniedStep["key"]);
		} else {
			routeTo = isSub ? denied_path : recommended;
		}
	} else {
		// Trying to go forward
		routeTo = isSub ? denied_path : recommended;
	}

	goTo(routeTo);
};

const isSubPath = (path) => {
	if (Flow.sub_paths[path]) {
		return true;
	}
	if (path.indexOf("vip-") !== -1) {
		return true;
	}
	return false;
};

const pathNumberOf = (path) => {
	if (Flow.paths[path]) {
		let step = Flow.paths[path]["order"];
		return step;
	}
	if (Flow.sub_paths[path]) {
		let order = Flow.sub_paths[path]["order"];
		return order;
	}
	return 1;
};

const stepNumberOf = (current) => {
	if (Flow.routes[current]) {
		let step = Flow.routes[current]["order"];
		return step;
	}
	return 0;
};


const isActivated = (flags = null) => {
	return (flags && flags.is_sim_activated);
};


const hasPaidOrMore = (flags = null) => {
	if (!flags) {
		flags = Storage.get("flow_status_flags");
	}
	return (
		flags &&
		(flags.is_plan_paid ||
			flags.is_sim_delivered ||
			flags.is_delivery_in_progress ||
			flags.is_sim_activated)
	);
};

const isDone = () => {
	let flags = Storage.get("flow_status_flags") || {};
	let isValidIdHolder = Storage.get('valid_id_holder', true, true);
	if(!isValidIdHolder){
		return (
			flags &&
			(flags.is_sim_delivered ||
				flags.is_delivery_in_progress ||
				flags.is_sim_activated || flags.is_plan_paid)
		);
	}
	return (
		flags &&
		(flags.is_sim_delivered ||
			flags.is_delivery_in_progress ||
			flags.is_sim_activated)
	);
};

const getRecommendedRoute = (callee = "default") => {
	let flags = Storage.get("flow_status_flags") || {};

	let routeTo = null;
	let done = isDone();
	// let navigating_within_app = Storage.get("navigating_within_app");

	if (Storage.get("filter_vip") || Storage.get("search")) {
		routeTo = "/number/search";
	} else {
		if (flags) {
			if (done) {
				routeTo = getStepBaseOf("thank_you");
			} else {
				let last_allowed = slash;

				for (let step of Object.keys(Flow.steps)) {
					let path = Flow.steps[step]["path"];

					if (isRouteAllowed(path, "5")) {
						let skip_it = false;
						if (Flow.steps[step]["skip_if"]) {
							for (let skipper of Flow.steps[step]["skip_if"]) {
								skip_it = checkFlag(skipper);
								if (!skip_it) {
									break;
								}
							}
						}

						if (skip_it) {
							continue;
						}

						last_allowed = path;

						break;
					}
				}

				routeTo = last_allowed;
			}
		} else {
			routeTo = slash;
		}
	}

	if (Storage.get("redirected_to_installment", true)){
		if (window.location.href.indexOf("/installment-success") !== -1) {
			routeTo = "/installment-success";
		  }
		  if (window.location.href.indexOf("/installment-fail") !== -1) {
			routeTo = "/installment-fail";
		  }
	}
	return routeTo;
};

const goHome = () => {
	goTo(slash);
};

const initFlow = () => {
	for (let step in Steps) {
		steps.push(Steps[step]);
		paths.push(Steps[step]);
	}

	Flow.routes = Steps;

	Flow.steps_count = steps.length;

	steps = steps.sort((a, b) => {
		return a.order - b.order;
	});

	steps = steps.map((item, index) => {
		item["order"] = index + 1;
		return item;
	});

	Flow.steps = arrayToObject(steps, "order");

	Flow.starting_path = steps[0];

	Flow.paths = arrayToObject(steps, "path");
	Flow.sub_paths = mapSubs(steps);

	Flow.loaded = true;

	obsrv.next(Flow.routeTo);
	loaded.next(Flow.loaded);
};

const getStartingPath = () => {
	return Flow.starting_path;
};

export {
	goHome,
	goToStart,
	goToHref,
	getRoutes,
	getStartingPath,
	goToRouteWithChecks,
	goToStepBase,
	getStepBaseOf,
	isRouteAFullURL,
	getCurrentRoute,
	getStepStyleByPath,
	getRouteObsrv,
	hasPaidOrMore,
	isActivated,
	getStepNameByPath,
	navigateFromDeniedPath,
	getStepByPath,
	pathNumberOf,
	isSubPath,
	initFlow,
	stepNumberOf,
	loadFlow,
	getNextRouteOf,
	getPrevRouteOf,
	goTo,
	next,
	back,
	isRouteAllowed,
	getStepOrderByPath,
	getRecommendedRoute,
	checkFlag,
};
